import {
  ImpactType,
  UserImpactAggregates,
  putCommasIntoNumber,
  roundTo,
  Wordpress,
} from "@ecologi/shared";
import React from "react";
import { getResizedImageURL } from "../..";
import { Link } from "../../Link";
import styles from "../styles/ProjectCard.module.scss";
import { Badge } from "./Badge";

type ProjectCardProps = {
  userImpactAggregates: UserImpactAggregates;
  project: Wordpress.Project;
};

export const ProjectCard = ({
  userImpactAggregates,
  project: featuredProject,
}: ProjectCardProps) => {
  const allProjectsIncludingCarbonOffsets =
    userImpactAggregates[ImpactType.CARBON_OFFSETS];

  const numberOfTonnes = allProjectsIncludingCarbonOffsets.data?.projects.find(
    (project) => project.id === featuredProject.id
  )?.impactQuantity;

  if (numberOfTonnes === undefined) {
    return null;
  }

  const numberOfTonnesRounded = putCommasIntoNumber(roundTo(2)(numberOfTonnes));
  // Prevent very small carbon amounts from appearing as 0.00
  const numberOfTonnesForDisplay =
    numberOfTonnesRounded === "0.00" ? "0.01" : numberOfTonnesRounded;

  const projectImageUrl = getResizedImageURL(
    featuredProject.images[0]?.url,
    704
  );

  return (
    <Link
      href={`/projects/${featuredProject.slug}`}
      className={styles.projectCard}
      data-testid="project-card"
    >
      {projectImageUrl && (
        <img
          className={styles.projectCardImage}
          src={projectImageUrl}
          alt=""
          loading="lazy"
        />
      )}
      <div className={styles.projectCardText}>
        <h3 className={styles.projectCardName}>{featuredProject.title}</h3>
        <p className={styles.projectCardDescription}>
          {featuredProject.description}
        </p>
        <div className={styles.projectCardBadge}>
          <Badge isYellow>{`${numberOfTonnesForDisplay}tCO2e avoided`}</Badge>
        </div>
      </div>
    </Link>
  );
};
